import MainButton from '@/components/Buttons/MainButton';
import React, { useEffect, useState } from 'react';
import { gamesData } from '@/utils/constants';
import { notify } from '@/utils/notify';
import AlertIcon from '@/components/Notifications/AlertIcon';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';
import { ApiRequest } from '@/utils/axios';
import { cartStore } from '@/stores/cart.store';
import { TSelectedGame } from '@/components/MainInventory/MainInventoryFilter';
import { IBaseItem } from '@/utils/types/Items';
import { modalStore } from '@/stores/modal.store';
import useUserStore from '@/stores/user.store';
import { useRouter } from 'next/router';
import { requireTradeLink } from '@/utils/requireTradeLink';

interface Props {
    selectedItems: IBaseItem[];
    selectedGame: TSelectedGame;
    total: number;
}

const DepositFooter = ({ selectedGame, selectedItems, total }: Props) => {
    const { setTitle, setComponent, toggleModal, setData } = modalStore((state) => state);
    const { user } = useUserStore((state) => state);
    const { clearCart } = cartStore((state) => state);

    const [mindep, setMindep] = useState(0);
    const [appid, setAppid] = useState(0);

    const router = useRouter();

    const game = gamesData[selectedGame];
    const disabled = total == 0;

    useEffect(() => {
        ApiRequest.get('/settings/list').then(
            ({
                data: {
                    response: {
                        deposit: { mindep },
                        global: { appid },
                    },
                },
            }) => {
                setMindep(parseFloat(mindep));
                setAppid(Number(appid));
            }
        );
    }, []);

    async function deposit(convert: boolean = false) {
        const game = gamesData[selectedGame];

        if (!user.tradeToken) {
            requireTradeLink();
            return;
        }

        if (total < mindep) {
            return notify(
                'error',
                <AlertIcon />,
                <NotifyWrapper title={'Error'} text={`Min deposit: $${mindep}`} />,
                10000
            );
        }

        const {
            data: {
                response: { offerId },
            },
        } = await ApiRequest.post('/market/buy/steam', {
            steamItems: selectedItems.map((item) => {
                return {
                    assetid: String(item.id),
                    contextid: game.contextId,
                    appid: game.appId,
                };
            }),
            convertToBalance: convert,
        });
        clearCart();
        setComponent('Steam trade');
        setTitle('CONFIRM TRADE');
        setData({ tradeId: offerId });
        toggleModal(true);
    }

    return (
        <div className={'flex flex-col gap-4'}>
            {appid == game.appId && (
                <MainButton
                    text={'DEPOSIT'}
                    onClick={() => deposit()}
                    disabled={disabled}
                    background={disabled ? '#9D9D9D' : ''}
                    className={`w-full text-white bg-blue`}
                />
            )}
            <MainButton
                text={'CONVERT TO CREDITS'}
                onClick={() => deposit(true)}
                disabled={disabled}
                className={'w-full bg-gray text-text_gray'}
            />
        </div>
    );
};

export default DepositFooter;
